import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SamwebBrick } from '../../samweb-brick.decorator';
import { BrickCategory } from '../../../../samwebDescription/samweb/brickCategoryType';
import { BasicBrickComponent } from '../../basic-brick-component';
import { WellKnownIconsEnum } from 'src/app/helper/iconHelper';

@Component({
   selector: 'samweb-brick-not-ready-brick',
   templateUrl: './brick-not-ready-brick.component.html',
   styleUrls: ['./brick-not-ready-brick.component.scss'],
   changeDetection: ChangeDetectionStrategy.OnPush,
})
@SamwebBrick({
   brickDefinitionId: BrickNotReadyBrickComponent.BrickId,
   brickTitleTranslationKey: 'brick.brick-management.brick-not-ready',
   brickDescriptionTranslationKey: null,
   brickIcon: WellKnownIconsEnum.NOT_READY.icon,
   minColWidth: 10,
   minRowHeight: 10,
   brickCategory: BrickCategory.DEBUG,
   disableAddingByUser: true,
   disallowBrickSettings: true,
})
export class BrickNotReadyBrickComponent extends BasicBrickComponent {
   public static BrickId = 'brickNotReady';
   public readonly icon = WellKnownIconsEnum.NOT_READY.icon;

   constructor() {
      super();
   }
}
